import i from"styled-components";import{BUTTON_STYLE as e}from"./helpers/defaults.js";import{options as o}from"./helpers/style-options.js";const n=i.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-color: ${({backgroundColor:i})=>i};
	border-radius: ${({borderRadius:i})=>`${i}px`};
	color: ${({color:i})=>i};
	border: 1px solid ${({border:i})=>i};
	padding-inline: ${({size:i,type:e})=>o.size[e][i].padding};
	height: ${({size:i,type:e})=>o.size[e][i].height};
	font-size: ${({size:i,type:e})=>o.size[e][i].fontSize};
	flex-flow: ${({iconPosition:i})=>o.iconPosition[i].flexFlow};
	white-space: nowrap;
	width: ${({width:i})=>i?`${i}px`:"auto"};
	min-width: fit-content;
	user-select: none;
	transition: background-color 0.2s ease;

	&:hover {
		${({hover:i,styleVariant:o,color:n,hoverBgColor:t,originalBackgroundColor:r})=>i?o===e.FILL?`\n            background-color: ${t};\n          `:void 0:""}
	}
`,t=i.div`
	display: grid;
	place-content: center;
	width: ${({size:i,type:e})=>o.size[e][i].iconSize};
	height: ${({size:i,type:e})=>o.size[e][i].iconSize};
`;i.div`
	display: grid;
	place-content: ${({align:i})=>o.align[i]};
`,i.div`
	display: flex;
	align-items: center;
	column-gap: 12px;
`;const r=i.input`
	border: none;
	outline: none;
	background-color: transparent;
	color: inherit;
	font-size: inherit;
	font-family: inherit;
	font-weight: inherit;
	line-height: inherit;
	height: 100%;
	padding: 0;
	margin: 0;
	field-sizing: content;
`;export{n as ButtonContainer,t as ButtonIconContainer,r as StyledEditableInput};
